const firebaseConfig = {
  apiKey: "AIzaSyBfoINF73mEMllsyZ8nPpWsi8jTkBfaPc8",
  databaseURL: 'https://taxatsource-4a8c0.firebaseio.com/',
  storageBucket: "gs://taxatsource-4a8c0.appspot.com/",
};

export default firebaseConfig;